import { Injectable } from '@angular/core';
import { LocalizationPipe } from '@shared/modules/localization';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class MessagesService {
  private durationInSeconds = 2;

  constructor(private message: NzMessageService, private localizationPipe: LocalizationPipe) {}

  public showSuccess(text: string): void {
    this.message.success(this.localizationPipe.transform(text) ?? '', {
      nzDuration: this.durationInSeconds * 1000,
      nzPauseOnHover: false,
    });
  }

  public showError(text: string): void {
    this.message.error(this.localizationPipe.transform(text) ?? '', {
      nzDuration: this.durationInSeconds * 1500,
      nzPauseOnHover: false,
    });
  }

  public showWarning(text: string, duration?: number): void {
    this.message.warning(this.localizationPipe.transform(text) ?? '', {
      nzDuration: (duration ?? this.durationInSeconds) * 1000,
      nzPauseOnHover: false,
    });
  }

  public hideAll(): void {
    this.message.remove();
  }
}
